import { createFileRoute, redirect } from '@tanstack/react-router';

import { VisitReportPage } from '@/features/design/visit-report-page';
import { bootSession } from '@/lib/auth/session';

/** Outside the app shell on purpose: a clean page for the browser's print / Save as PDF. */
export const Route = createFileRoute('/print/projects/$projectId/site-visits/$visitId')({
  beforeLoad: async ({ location }) => {
    const session = await bootSession();
    if (session.status === 'signed_out') {
      throw redirect({ to: '/signin', search: { return_to: location.href } });
    }
  },
  component: PrintRoute,
});

function PrintRoute() {
  const { projectId, visitId } = Route.useParams();
  return <VisitReportPage projectId={projectId} visitId={visitId} />;
}
